/**
 * @generated SignedSource<<0aabac3306a0924ad54330a4d7cd4682>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultLayout_Query$variables = Record<PropertyKey, never>;
export type defaultLayout_Query$data = {
  readonly viewer: {
    readonly customer: {
      readonly firstName: string | null | undefined;
      readonly isCompany: boolean;
      readonly lastName: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"mainNavigation_fragment" | "notifications_fragment" | "stickyChat_fragment">;
    } | null | undefined;
  } | null | undefined;
};
export type defaultLayout_Query = {
  response: defaultLayout_Query$data;
  variables: defaultLayout_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompany",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "read",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "CaseRelation",
  "kind": "LinkedField",
  "name": "relationType",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "relationType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "baseCase",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v9/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "AppointmentActivity",
    "kind": "LinkedField",
    "name": "appointmentActivity",
    "plural": false,
    "selections": [
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "location",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "baseCase",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v11/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endDate",
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  (v6/*: any*/)
],
v14 = [
  (v5/*: any*/),
  (v11/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CaseRelation",
    "kind": "LinkedField",
    "name": "relationType",
    "plural": false,
    "selections": [
      (v8/*: any*/)
    ],
    "storageKey": null
  },
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "defaultLayout_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Customer",
            "kind": "LinkedField",
            "name": "customer",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "notifications_fragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "mainNavigation_fragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "stickyChat_fragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "defaultLayout_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Customer",
            "kind": "LinkedField",
            "name": "customer",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "NotificationInterfaceConnection",
                "kind": "LinkedField",
                "name": "notificationConnection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationInterfaceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isNotificationInterface"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "threadId",
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subject",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "authorName",
                                "storageKey": null
                              }
                            ],
                            "type": "MessageNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Document",
                                "kind": "LinkedField",
                                "name": "document",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "documentTypeName",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              (v6/*: any*/)
                            ],
                            "type": "DocumentSigningNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "ActivityNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "searchProfile",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "type": "SearchProfileMatchNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "typeName",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "type": "RequestedDocumentNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SearchProfileMatchedCase",
                                "kind": "LinkedField",
                                "name": "searchProfileMatchedCase",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "baseCase",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v11/*: any*/),
                                      (v9/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "searchProfile",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v12/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "SearchProfileMatchedCaseNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "baseCase",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "caseNo",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v11/*: any*/)
                            ],
                            "type": "DocumentAccessGrantedNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "lead",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "statusType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LeadTypeGraphType",
                                    "kind": "LinkedField",
                                    "name": "type",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "displayName",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "receivedDate",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LeadNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "case",
                                "plural": false,
                                "selections": (v14/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "PriceChangeOnFavoriteCaseNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SearchProfileMatchedCase",
                                "kind": "LinkedField",
                                "name": "searchProfileMatchedCase",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "baseCase",
                                    "plural": false,
                                    "selections": (v14/*: any*/),
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PriceChangedOnMatchedCaseNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "OpenHouseOnFavoriteCaseNotification",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "notificationConnection(first:12)"
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "mainNavigation_notificationConnection",
                "kind": "LinkedHandle",
                "name": "notificationConnection"
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unreadNotificationsCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unreadThreadCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "89a8d28d5c3c3747bf8659e3e396ae36",
    "id": null,
    "metadata": {},
    "name": "defaultLayout_Query",
    "operationKind": "query",
    "text": "query defaultLayout_Query {\n  viewer {\n    customer {\n      firstName\n      isCompany\n      lastName\n      ...notifications_fragment\n      ...mainNavigation_fragment\n      ...stickyChat_fragment\n      id\n    }\n    id\n  }\n}\n\nfragment activityNotification_fragment on ActivityNotification {\n  read\n  appointmentActivity {\n    name\n    location\n    baseCase {\n      __typename\n      address\n      id\n    }\n    startDate\n    endDate\n    id\n  }\n  createdDate\n}\n\nfragment documentAccessGrantedNotification_fragment on DocumentAccessGrantedNotification {\n  baseCase {\n    __typename\n    relationType {\n      relationId\n      relationType\n    }\n    caseNo\n    id\n  }\n  id\n  createdDate\n  read\n  address\n}\n\nfragment documentSigningNotification_fragment on DocumentSigningNotification {\n  read\n  baseCase {\n    __typename\n    relationType {\n      relationId\n      relationType\n    }\n    id\n  }\n  document {\n    documentTypeName\n    id\n  }\n  address\n  createdDate\n}\n\nfragment leadNotification_fragment on LeadNotification {\n  read\n  lead {\n    __typename\n    statusType\n    type {\n      displayName\n      id\n    }\n    receivedDate\n    id\n  }\n}\n\nfragment mainNavigation_fragment on Customer {\n  unreadNotificationsCount\n  unreadThreadCount\n  ...notifications_fragment\n}\n\nfragment messageNotification_fragment on MessageNotification {\n  createdDate\n  read\n  subject\n  authorName\n}\n\nfragment notificationComponent_fragment on NotificationInterface {\n  __isNotificationInterface: __typename\n  __typename\n  ... on MessageNotification {\n    threadId\n  }\n  ...messageNotification_fragment\n  ...documentSigningNotification_fragment\n  ...activityNotification_fragment\n  ...searchProfileMatchNotification_fragment\n  ...requestedDocumentNotification_fragment\n  ...searchProfileMatchedCaseNotification_fragment\n  ...documentAccessGrantedNotification_fragment\n  ...leadNotification_fragment\n  ...priceChangeFavoriteCaseNotification_fragment\n  ...priceChangeOnMatchCaseNotification_fragment\n  ...openHouseFavoriteCaseNotification_fragment\n}\n\nfragment notifications_fragment on Customer {\n  notificationConnection(first: 12) {\n    edges {\n      node {\n        id\n        __typename\n        ...notificationComponent_fragment\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment openHouseFavoriteCaseNotification_fragment on OpenHouseOnFavoriteCaseNotification {\n  read\n  appointmentActivity {\n    name\n    location\n    baseCase {\n      __typename\n      address\n      id\n    }\n    startDate\n    endDate\n    id\n  }\n  createdDate\n}\n\nfragment priceChangeFavoriteCaseNotification_fragment on PriceChangeOnFavoriteCaseNotification {\n  id\n  read\n  createdDate\n  case {\n    __typename\n    address\n    relationType {\n      relationId\n    }\n    id\n  }\n}\n\nfragment priceChangeOnMatchCaseNotification_fragment on PriceChangedOnMatchedCaseNotification {\n  id\n  read\n  createdDate\n  searchProfileMatchedCase {\n    baseCase {\n      __typename\n      address\n      relationType {\n        relationId\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment requestedDocumentNotification_fragment on RequestedDocumentNotification {\n  read\n  baseCase {\n    __typename\n    relationType {\n      relationId\n      relationType\n    }\n    id\n  }\n  typeName\n  createdDate\n}\n\nfragment searchProfileMatchNotification_fragment on SearchProfileMatchNotification {\n  read\n  searchProfile {\n    __typename\n    id\n    name\n  }\n  createdDate\n}\n\nfragment searchProfileMatchedCaseNotification_fragment on SearchProfileMatchedCaseNotification {\n  id\n  createdDate\n  __typename\n  read\n  searchProfileMatchedCase {\n    baseCase {\n      __typename\n      address\n      relationType {\n        relationId\n        relationType\n      }\n      id\n    }\n    id\n  }\n  searchProfile {\n    __typename\n    name\n    id\n  }\n}\n\nfragment stickyChat_fragment on Customer {\n  unreadThreadCount\n}\n"
  }
};
})();

(node as any).hash = "007032a5a62653e5ef24837f6aba7e21";

export default node;
